import { jsx } from "react/jsx-runtime";
import { LOAN_TERM_IN_MONTHS } from "../../utils/zhl-calculator.esm.js";
import VALoanCalculator from "../VALoanCalculator/VALoanCalculator.esm.js";
import { FieldConfig } from "../VALoanCalculator/VALoanCalculator.utils.esm.js";
const attributes = {
  [FieldConfig.homePrice.name]: {
    type: "number",
    label: "Default home price",
    default: 225e3,
    control: "number"
  },
  [FieldConfig.loanProgram.name]: {
    type: "number",
    label: "Default loan program",
    default: 360,
    control: "select",
    choices: FieldConfig.loanProgram.options
  },
  [FieldConfig.interestRate.name]: {
    type: "number",
    label: "Default interest rate",
    default: 5,
    control: "number"
  },
  [FieldConfig.downPayment.name]: {
    type: "number",
    label: "Default down payment",
    default: 45e3,
    control: "number"
  },
  [FieldConfig.downPaymentPercent.name]: {
    type: "number",
    label: "Default down payment percent",
    default: 20,
    control: "number"
  },
  [FieldConfig.homeInsurance.name]: {
    type: "number",
    label: "Default home insurance",
    default: 945,
    control: "number"
  },
  [FieldConfig.hoa.name]: {
    type: "number",
    label: "Default hoa dues",
    default: 0,
    control: "number"
  },
  [FieldConfig.taxRate.name]: {
    type: "number",
    label: "Default property tax",
    default: 3600,
    control: "number"
  },
  [FieldConfig.taxRatePercent.name]: {
    type: "number",
    label: "Default property tax percent",
    default: 1.2,
    control: "number"
  },
  [FieldConfig.includeTaxesInsurance.name]: {
    type: "boolean",
    default: "true",
    label: "Default include taxes/insurance",
    control: "boolean"
  },
  [FieldConfig.includePMI.name]: {
    type: "boolean",
    defaulat: "true",
    label: "Default include private mortgage insurance",
    control: "boolean"
  }
};
const MortgageCalculatorBlock = {
  Component: () => {
    return /* @__PURE__ */ jsx(VALoanCalculator, { isMortgageComponent: true });
  },
  metadata: {
    version: "1.0",
    name: "constellation/mortgage-calculator",
    title: "Mortgage Calculator",
    description: "Estimate monthly payments.",
    icon: "index-card",
    keywords: ["mortgages", "calculators"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    //added seperate attributes as default value varies for many fields
    attributes,
    //to avoid migration issues, add previous configs in deprecated section
    deprecated: [{
      attributes: {
        loanProgram: {
          type: "string",
          default: "Fixed30Year"
        }
      },
      save: () => null,
      isEligible: ({
        loanProgram
      }) => typeof loanProgram === "string",
      migrate({
        loanProgram,
        ...rest
      }) {
        return {
          ...rest,
          loanProgram: LOAN_TERM_IN_MONTHS[loanProgram]
        };
      }
    }]
  }
};
export {
  MortgageCalculatorBlock as default
};
